/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Source_TitleInputs */

const en_fc_dl_source_title = /** @type {(inputs: Fc_Dl_Source_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build from source`)
};

/**
* | output |
* | --- |
* | "Build from source" |
*
* @param {Fc_Dl_Source_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_source_title = /** @type {((inputs?: Fc_Dl_Source_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Source_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_source_title(inputs)
});
export { fc_dl_source_title as "fc.dl.source.title" }